import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DropDownButtonItemDirective, DropDownButtonItemsDirective } from './items.directive';
import { DropDownButtonComponent } from './dropdownbutton.component';
/**
 * NgModule definition for the DropDownButton component.
 */
export class DropDownButtonModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule],
    declarations: [
        DropDownButtonComponent,
        DropDownButtonItemDirective,
        DropDownButtonItemsDirective
    ],
    exports: [
        DropDownButtonComponent,
        DropDownButtonItemDirective,
        DropDownButtonItemsDirective
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DropDownButtonModule_tsickle_Closure_declarations() {
/** @type {?} */
DropDownButtonModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DropDownButtonModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
